import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import type { ResponseNumeric } from "../../../ManageQuestions/types";

type Props = {
  response: ResponseNumeric;
  disabled?: boolean;
  value?: number | null;
  onCommit: (value: number | null) => void;
  reveal?: boolean;
};

const NumericWidget: React.FC<Props> = ({ response, disabled, value = null, onCommit, reveal }) => {
  const [txt, setTxt] = useState<string>(value != null ? String(value) : "");
  useEffect(() => setTxt(value != null ? String(value) : ""), [value]);

  const commit = () => {
    const v = txt.trim() === "" ? null : Number(txt);
    onCommit(Number.isFinite(v as any) ? v : null);
  };

  const target = response.evaluation?.range?.target;
  const tol = response.evaluation?.range?.tolerance;

  return (
    <div className="tap-inputrow">
      <input
        className="tap-input"
        type="number"
        value={txt}
        onChange={(e) => setTxt(e.target.value)}
        onBlur={commit}
        disabled={disabled}
        placeholder={response.input_rules?.units ? `Value (${response.input_rules.units})` : "Value"}
      />
      <Button size="sm" variant="primary" onClick={commit} disabled={disabled}>Save</Button>
      {reveal && (target != null) && (
        <div className="tap-reveal-hint">
          Target: <b>{target}</b>{tol != null ? ` (±${tol})` : ""}
        </div>
      )}
    </div>
  );
};

export default NumericWidget;
